module.exports = __webpack_public_path__ + "static/media/thankme.4483a4ac.svg";